import { DropdownMenu, MenuBlock } from "@jds/core";
import { Box } from "@mui/material";
import React, { useState, useRef } from "react";

export default function MenuButton(props) {
  const TriggerComponent = props?.trigger?.component;

  const ref = useRef();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      {props?.trigger && (
        <Box ref={ref} sx={{ cursor: "pointer " }}>
          <TriggerComponent onClick={handleClick} {...props.trigger.props} />
        </Box>
      )}
      <DropdownMenu
        onClick={(e) => {
          e.stopPropagation();
        }}
        open={open}
        onClose={handleClose}
        anchorEl={ref}
        onSelect={(value) => {}}
        {...props}
      >
        {props.children}
      </DropdownMenu>
    </>
  );
}
